module.exports = __webpack_public_path__ + "media/images/features/take_it_with_you_img-3cfabae50f14b81c60487a511b57deb8.png";